import { ProjectInterface } from '../../models/project.model';
import axiosService from '../../services/axios/axios.service';

const getProjects = async (query: {
    search: string;
    status: boolean;
    page: number;
    limit: number;
}): Promise<NonNullable<ProjectInterface>[]> => {
    const response = await axiosService.get('/project/projects', {
        params: query,
    });
    return response.data;
};

const updateProject = async (payload: ProjectInterface) => {
    const response = await axiosService.patch(
        `/project/update/${payload._id}`,
        payload
    );
    return response.data;
};

const createProject = async (payload: ProjectInterface) => {
    const response = await axiosService.post('/project/create', payload);
    return response.data;
};

const deleteProject = async (id: string) => {
    const response = await axiosService.delete(`/project-common/delete-project/${id}`);
    return response.data;
};

const addProjectMember = async (payload: {
    projectId: string;
    members: {
        uid: string;
        role: string;
    }[];
}) => {
    const response = await axiosService.post(
        '/project-member/add-members',
        payload
    );
    return response.data;
};

const getProjectMembers = async (
    projectId: string,
    status?: boolean | string
) => {
    const response = await axiosService.get(
        `/project-member/get-all/${projectId}?status=${status}`
    );
    return response.data;
};

const updateProjectMember = async (payload: {
    projectMemberId: string;
    status: boolean;
    role: string;
}) => {
    const response = await axiosService.put(`/project-member/update`, payload);
    return response.data;
};

const removeProjectMember = async (projectMemberId: string) => {
    const response = await axiosService.delete(
        `/project-member/delete/${projectMemberId}`
    );
    return response.data;
};

const getProjectById = async (
    projectId: string
): Promise<NonNullable<ProjectInterface>> => {
    const response = await axiosService.get(
        `/project/get-project/${projectId}`
    );
    return response.data;
};

export {
    getProjects,
    updateProject,
    createProject,
    deleteProject,
    addProjectMember,
    getProjectMembers,
    updateProjectMember,
    removeProjectMember,
    getProjectById,
};
